// extracted by mini-css-extract-plugin
module.exports = {"author":"e_O4"};